import { render, staticRenderFns } from "./wtCarouselGallery.component.vue?vue&type=template&id=8df9cb36&scoped=true&"
import script from "./wtCarouselGallery.component.vue?vue&type=script&lang=js&"
export * from "./wtCarouselGallery.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df9cb36",
  null
  
)

export default component.exports